export const projectIdSet = projectId => ({
  widget: 'global',
  type: 'projectIdSet',
  payload: { projectId },
})



// WEBPACK FOOTER //
// ./src/global/actions/projectIdSet.js